<template>
  <el-container :style="{height:mainHeight-10+'px'}" direction="vertical" class="divBody"><!---->
    <PwdBox v-if="bbPwd" :f1_action="savePwd"/>
    <div v-if="!bbFull" class="divTop">
      <p class="divTop_p1">{{ userCompany }}</p>
      <p class="divTop_p2">
        你好，{{ userNm }}
        |
        <a @click="toPwd">修改密码</a>
        |
        <a @click="toLogin">退出</a>
        |
        <a @click="rmCache">{{ rmCacheMsg }}</a>
        |
        {{ $keys().version }}
      </p>
    </div>
    <div class="divMain"><!-- :style="{height:$getWH().mH+'px'}"-->
      <!--左菜单-->
      <div v-show="bbBarV && !bbFull" class="divML">
        <p class="pActive" @click="p31_activeBar">
          ◀▪
        </p>
        <div v-for="mm in menus" :key="mm.fidmenu" class="divMenu">
          <div :class="mm.fopen?'divMenu01pk':'divMenu01'" @click="expendMenu(mm)">
            <i :class="mm.ficon" style="padding-right: 5px;"/>
            {{ mm.fnamemenu }}
            <i
              v-if="mm.fchildren && mm.fchildren.length>0"
              :class="mm.fopen?'el-icon-arrow-up':'el-icon-arrow-down'"
              style="float:right;"/>
          </div>
          <div v-show="mm.fopen" class="divMenu02"><!---->
            <p v-for="mb in mm.children" :key="mb.fidmenu" :class="mb.active?'divMenu02pp':''" @click="openMenu(mb)">
              <i :class="mb.ficon" style="padding-right: 5px;"/>
              {{ mb.fnamemenu }}
            </p>
          </div>
        </div>
      </div>
      <div
        v-show="!bbBarV && !bbFull"
        class="divActive"
        @click="p31_activeBar">▪▶</div>
      <!--操作区-->
      <div :style="[{width:bbFull?'100%':$getWH().orgW-(bbBarV?180:45)+'px'}]" class="p5px">
        <!--标题栏-->
        <div v-if="!bbFull" class="divMRT">
          <CMenubox
            v-for="mm in menuPks"
            :key="mm.fidmenu"
            :p_id="mm.fidmenu"
            :p_title="mm.fnamemenu"
            :p_active="mm.active"
            :a_act="pkTab"
            :a_close="clsTab"/>
        </div>
        <!--操作区-->
        <div :style="[{height:bbFull?'100%':$getWH().mH-100+'px'},{'overflow':bbFull?'auto':'hidden'}]">
          <div v-for="mm in menuPks" :key="mm.fidmenu">
            <!--1.常规列表，点击进明细编辑 -->
            <!--2.编辑列表，直接在列表编辑 、保存-->
            <!--3.仅读列表，没的点击-->
            <!--5.图表-->
            <CList
              v-if="!mm.fidtype||mm.fidtype>30000"
              :p-height="mainHeight"
              :p_active="mm.active"
              :to-do="toDo"
              :p_menu="mm"/><!--v-if="mm.fidmenu>1"-->
            <Chart
              v-if="mm.fidtype===5"
              :p_active="mm.active"/>
          </div>
        </div>
      </div>
    </div>
  </el-container>
</template>
<script>
import dtUtil from '../utils/dateUtil'
import PwdBox from '../comps/c3_tools/04_pwd.vue'
import CMenubox from '../comps/c1_tab/01_menubox.vue'
import CList from '../comps/c2_info/01_list.vue'
// import Chart from '../comps/c2_info/05_chart.vue'
import Chart from '../comps/c3_tools/09_chart.vue'
// import Chart from '../comps/c3_tools/08_chart.vue'
import Perview from '../comps/c2_info/07_perview.vue'
import ICPeriod from '../comps/c2_info/10_icperiod.vue'
export default {
  name: 'PgHi',
  components: {
    CMenubox,
    PwdBox,
    CList,
    Chart,
    Perview,
    ICPeriod
  },
  data() {
    return {
      bbBarV: true,
      bbLoading: false,
      bbPwd: false,
      bbFull: false,
      rmCacheMsg: '清理缓存',
      mainWidth: 0,
      mainHeight: 0,
      userNm: 'tak',
      userCompany: '',
      menus: [],
      menuPks: []
    }
  },
  activated: function() {
    this.initMenu()
  },
  mounted() {
    setInterval(() => {
      this.rToken()
    }, 1000 * 60 * 28)//
    const my = this
    this.mainHeight = this.$getWH().orgH
    this.mainWidth = this.$getWH().orgW
    // my.prt('mounted,mainHeight', this.mainHeight)
    window.addEventListener('resize', () => {
      my.mainWidth = document.body.clientWidth
      my.mainHeight = document.body.clientHeight
    })/*
    window.onresize = () => {
      my.prt('mounted,document.body.clientWidth', document.body.clientWidth)
      return (() => {
        my.mainHeight = document.body.clientHeight
      })()
    }*/
  },
  methods: {
    prt(actNm, info) {
      console.log('PgHi.' + actNm, info)
    },
    p31_activeBar() {
      this.prt('p31_activeBar', this.bbBarV)
      this.bbBarV = !this.bbBarV
    },
    /**
     iAct:31关闭edit
          51echart click
     */
    toDo(iAct, param) {
      this.prt('toDo.iAct', iAct)
      if (iAct === 31) this.clsTab(param)
      if (iAct === 103) {
        this.bbFull = !this.bbFull// 全屏显示
        this.vwFull()
      }
    },
    pkTab(fid) {
      const list = []
      this.menuPks.forEach(row => {
        // row.active = (row.fid === fid)
        if (row.fidmenu === fid) {
          row.active = true
        } else {
          row.active = false
        }
        list.push(row)
      })
      this.menuPks = list
      this.prt('pkTab.' + fid, this.menuPks)
    },
    clsTab(fid) {
      this.menuPks.forEach((row, e) => {
        // this.prt('clsTab.1', e)
        if (row.fidmenu === fid) {
          this.menuPks.splice(e, 1)
          return
        }
      })
    },
    initMenu() {
      this.userCompany = localStorage.getItem('userCompany')
      this.userNm = localStorage.getItem('userNm')
      this.menus = []
      this.menuPks = []
      this.comm.pkDbData('menus', rs => {
        this.prt('initMenu.1', rs)
        rs.forEach(row => {
          if (row.fidparent === 0) {
            row['fopen'] = false
          }
          row['fidmenu'] = this.comm.toNum(row['fidmenu'])
          row['fidtype'] = this.comm.toNum(row['fidtype'])
          row['fidparent'] = this.comm.toNum(row['fidparent'])

          if (this.comm.toNum(row.fidparent) === 0) this.menus.push(row)
          else {
            this.menus.forEach(row2 => {
              if (row2.fidmenu === row.fidparent) {
                if (row2.children) {
                  row2.children.push(row)
                } else row2['children'] = [row]
              }
            })
          }
        })
        this.menus = this.menus.sort(this.comm.sortArr('fcodemenu', true))
        this.openMenu(this.menus[0])
      })
    },
    toLogin() {
      window.localStorage.clear()
      this.comm.rmDbData()
      this.$router.replace({
        path: '/',
        query: { }
      })
    },
    expendMenu(menu) {
      if (menu.furl) this.openMenu(menu)
      else menu.fopen = !menu.fopen
    },
    openMenu(subMenu) {
      this.prt('openMenu.1', subMenu)
      let bbExist = false
      const list = []
      this.menuPks.forEach(row => {
        if (row.fidmenu === subMenu.fidmenu) {
          bbExist = true
          row.active = true
        } else {
          row.active = false
        }
        list.push(row)
      })
      this.prt('openMenu.2', bbExist)
      if (!bbExist) {
        subMenu.active = true
        list.push(subMenu)
      }
      this.menuPks = list
    },
    rToken() {
      const dtNow = new Date()
      const mmDiff = dtUtil.dtDiff(this.$keys().tmLastRequest, dtNow, 'mm')
      this.prt('rToken.mmDiff', mmDiff)
      if (mmDiff < 29) {
        this.prt('rToken.30分钟内 可以刷新TOKEN', mmDiff)
        this.$iPost('/login/rToken', rs => {
          if (rs && rs.data) localStorage.setItem('token', rs.data)
        })
      } else {
        this.prt('rToken.超30分钟没请求了 重新登录', mmDiff)
      }
    },
    rmCache() {
      this.bbLoading = true/**/
      const token = localStorage.getItem('token')
      window.localStorage.clear()
      localStorage.setItem('token', token)
      this.comm.rmDbData()
      setTimeout(() => {
        this.initTree()
      }, 1500)
    },
    toPwd() {
      this.bbPwd = true
    },
    // TODO:管理端、客户端如果不同url，。。。
    savePwd(pwd1, pwd2) {
      if (!pwd1) {
        this.bbPwd = false
        return
      }
      const bbCust = localStorage.getItem('bbCust')
      const param = {
        fcode: this.comm.toAsc(pwd2),
        fpwd: this.comm.toAsc(pwd1),
        iAct: bbCust ? 8 : 7
      }
      this.$iPost('/login/upPwd', param).then(
        rs => {
          console.log('upPwd:', rs)
          if (rs.data.stat && rs.data.data[0].fid !== '0') {
            this.bbPwd = false
            this.toLogin()
          } else {
            alert('修改不成功')
          }
        }
      ).catch(
        rs => {
          this.bbLogin = false
          alert('修改不成功:' + rs)
        }
      )
    },
    vwFull() {
      // 获取要全屏的元素
      if (this.bbFull) {
        var element = document.documentElement
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.mozRequestFullScreen) { // Firefox
          element.mozRequestFullScreen()
        } else if (element.webkitRequestFullscreen) { // Chrome, Safari and Opera
          element.webkitRequestFullscreen()
        } else if (element.msRequestFullscreen) { // IE/Edge
          element.msRequestFullscreen()
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) { // Firefox
          document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) { // Chrome, Safari and Opera
          document.webkitExitFullscreen()
        } else if (document.msExitFullscreen) { // IE/Edge
          document.msExitFullscreen()
        }
      }
    }
  }
}
</script>
<style scoped>
.divBody{
  overflow-y: hidden; /***/
}
.pActive{
  width: 100%;
  height: 20px;
  cursor: pointer;
  color:rgb(23, 82, 172);
  text-align: right;
  font-size:20px;
}
.divActive{
  width: 25px;
  height: 16%;
  color:gold;
  padding: 15% 0;
  font-size: 20px;
  cursor: pointer;
  text-align: center;
  border-bottom-right-radius: 15px;
  background-image: linear-gradient(rgb(23, 82, 172),rgb(30, 51, 145),rgb(20, 48, 88),rgb(23, 82, 172));/*
  background-image: linear-gradient(rgba(39, 63, 71, 0.904),rgba(59, 92, 102, 0.904),rgba(47, 72, 80, 0.904),rgba(39, 63, 71, 0.904));*/
}
.divTop{
  display: flex;
  flex-direction: row;
  height: 6%;
  min-height: 20px;
  max-height: 30px;
  padding: 5px 20px;
  color:rgb(245, 245, 245);
  overflow: hidden;
  background-image: linear-gradient(rgb(30, 51, 145),rgb(20, 48, 88),rgb(23, 82, 172));/*
  background-image: linear-gradient(rgba(39, 63, 71, 0.904),rgba(59, 92, 102, 0.904),rgba(47, 72, 80, 0.904),rgba(39, 63, 71, 0.904));*/

}
.divTop_p1{
  width: 70%;
  font-size: 15px;
  font-weight: bold;
  padding-top: 7px;
}
.divTop_p2{
  width: 30%;
  text-align: right;
  font-size: 12px;
  padding-top: 10px;
  padding-right: 20px;
  color:rgb(195, 204, 216);
}
.divTop_p2 a{
  color:rgb(195, 204, 216);
}
.divTop_p2 a:hover{
  cursor: pointer;
}
.divMain{
  display: flex;
  flex-direction: row;
	width:100%;
  height: 94%;
	margin:0;
	padding:0;
	/*overflow:hidden;
  background-image: linear-gradient(white,rgb(236, 244, 255),rgb(223, 236, 255));
*/}
.divML{
/**  width: 150px; */
  min-width: 150px;
  padding: 5px;
  overflow-y: auto;
  overflow-x: hidden;
  border-right: 3px solid rgba(39, 63, 71, 0.904);
  /**border-top-right-radius: 8px;*/
  border-bottom-right-radius: 6px;
}
.divMenu{
  color: #6d737a;
}
.divMenu01{
  color: #6d737a;
  padding: 10px 5px;
}
.divMenu01:hover{
  color: #66b0ff;
  cursor: pointer;
}
.divMenu01pk{
  color: #578ec9;
  cursor: pointer;
  padding: 10px 5px;
}
.divMenu02{
  padding-left: 25px;
}
.divMenu02 p{
  padding: 10px 0;
}
.divMenu02 p:hover{
  color: #66b0ff;
  cursor: pointer;
}
.divMenu02pp{
  color: #66b0ff;
  cursor: pointer;
  padding: 10px 0;
}

.divMRT{
  display: flex;
  flex-direction: row;
  height: 30px;
  border-bottom: 1px solid rgb(107, 107, 107);
  overflow: auto;
}

</style>



// WEBPACK FOOTER //
// src/pages/p02_hi.vue